module.exports = __webpack_public_path__ + "static/nectar-museum-2-abf0699c155d3bae5a0a3d9d08be0056.jpg";